import { supabase } from '../supabaseClient';

export type ClassPurgeOwner = {
  userId: string;
  email: string | null;
  classes: number;
  bundles: number;
  years: number[];
};

export type ClassPurgePreview = {
  classCount: number;
  bundleCount: number;
  limitPerRun: number;
  owners: ClassPurgeOwner[];
};

export type ClassPurgeResult = {
  processed: number;
  classesDeleted: number;
  bundlesDeleted: number;
  results: Array<{ id: string; ok: boolean; error?: string }>;
  bundles: Array<{ id: string; ok: boolean; error?: string }>;
};

async function invokePurge<T>(dryRun: boolean): Promise<T> {
  const { data, error } = await supabase.functions.invoke('purge-expired-classes', { body: { dryRun } });
  if (error) throw new Error(error.message || '보관 기간 만료 자료 정리 호출에 실패했습니다.');
  const body = (data ?? {}) as { ok?: boolean; error?: string } & T;
  if (!body.ok) throw new Error(body.error || '보관 기간 만료 자료 정리에 실패했습니다.');
  return body;
}

export const previewExpiredClassPurge = () => invokePurge<ClassPurgePreview>(true);
export const runExpiredClassPurge = () => invokePurge<ClassPurgeResult>(false);
